// ============================================================
//  MASAMADREAM — Achievements System
//  Fase 6: logros desbloqueables basados en historial
// ============================================================

export const ACHIEVEMENTS = {
  iniciado: {
    id:    'iniciado',
    emoji: '🌿',
    title: 'Iniciado',
    desc:  'Completaste tu primer proceso',
  },
  first_p1: {
    id:    'first_p1',
    emoji: '🌱',
    title: 'Primer Cultivo',
    desc:  'Completaste tu primera fermentación de 7 días',
  },
  first_p2: {
    id:    'first_p2',
    emoji: '🍞',
    title: 'Primera Hogaza',
    desc:  'Completaste tu primer proceso de preparación de pan',
  },
  perseverante: {
    id:    'perseverante',
    emoji: '💪',
    title: 'Perseverante',
    desc:  'Completaste 2 procesos en total',
  },
  maestro: {
    id:    'maestro',
    emoji: '🏆',
    title: 'Maestro de la Masa',
    desc:  'Completaste tanto la fermentación como la preparación',
  },
  estrella: {
    id:    'estrella',
    emoji: '⭐',
    title: 'Panadero Estrella',
    desc:  'Calificaste un proceso con 5 estrellas',
  },
};

/**
 * Check all achievement conditions against current history.
 * Returns array of newly unlocked achievement objects.
 * @param {Store} store
 * @returns {Array}
 */
export function checkAchievements(store) {
  const state     = store.load();
  const history   = state.history || [];
  const completed = history.filter(p => p.outcome === 'completed');
  const newlyUnlocked = [];

  function tryUnlock(id) {
    if (store.unlockAchievement(id)) {
      newlyUnlocked.push(ACHIEVEMENTS[id]);
    }
  }

  // 🌿 Iniciado — first completed process
  if (completed.length >= 1)                         tryUnlock('iniciado');
  // 🌱 Primer Cultivo — first P1
  if (completed.some(p => p.type === 'p1'))          tryUnlock('first_p1');
  // 🍞 Primera Hogaza — first P2
  if (completed.some(p => p.type === 'p2'))          tryUnlock('first_p2');
  // 💪 Perseverante — 2+ completed
  if (completed.length >= 2)                         tryUnlock('perseverante');
  // 🏆 Maestro — completed both P1 and P2
  if (
    completed.some(p => p.type === 'p1') &&
    completed.some(p => p.type === 'p2')
  )                                                  tryUnlock('maestro');
  // ⭐ Estrella — rated 5/5
  if (completed.some(p => p.rating === 5))           tryUnlock('estrella');

  return newlyUnlocked;
}
